import React from 'react';
import { Link } from 'react-router-dom';
import './GetStarted.css';

export default function GetStarted() {
    return (
        <section id="get-started-section" className="get-started-section">
            <div className="get-started-container">
                <div className="get-started-content">
                    {/* Left Side - Image */}
                    <div className="get-started-image">
                        <div className="get-started-image-wrapper">
                            <img 
                                src="/images/lets-get-started.jpg" 
                                alt="Music Education" 
                                className="get-started-img"
                            />
                            <div className="get-started-image-overlay">
                                <div className="get-started-badge">
                                    <span className="badge-text">2025 Intake</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Right Side - Content */}
                    <div className="get-started-info">
                        <div className="get-started-header">
                            <h2 className="section-title">Let's Get Started</h2>
                            <div className="section-divider"></div>
                        </div>
                        <div className="get-started-description">
                            <p>Whether you’re exploring music for the first time or aiming to become a professional artist, our personalized programs, expert faculty, and structured curriculum ensure that every step you take is guided with care and precision. From vocals to instruments, live performance training to certification pathways, we help you build strong foundations and grow into a confident, versatile musician. Your stage starts here.</p>
                        </div>
                        <div className="get-started-actions">
                            {/* <Link to="/dual-program" className="get-started-btn">
                                Find The Right Program
                            </Link> */}
                            <Link to="/contact" className="get-started-btn">
                                Request Information
                            </Link>
                            <Link to="/admission-form" className="get-started-btn">
                                Start Your Application
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
